import { StoreApplication } from "../domain/store";
import { getStoreService } from "../infrastructure/services/getStoreService";

export const getStore = {
    async execute(): Promise<StoreApplication> {
        return await getStoreService.execute();
    },
};
